import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { GetAdminRequest } from '../../models/super-admin/getAdminRequest';
import { apiResponse } from '../../models/apiResponse';
import { AdminResponse } from '../../models/super-admin/adminResponse';
import { Observable } from 'rxjs';
import { RegisterAdminRequest } from '../../models/super-admin/registerAdminRequest';
import { UpdateAdminRequest } from '../../models/super-admin/updateAdminRequest';
import { StudentListForSuperAdminResponse } from '../../models/super-admin/studentListForSuperAdminResponse';
import { StudentListForSuperAdminRequest } from '../../models/super-admin/studentListForSuperAdminRequest';
import { loginResponse } from '../../models/account/loginResponse';
import { AllMentorsScheduledCallResponse } from '../../models/super-admin/allMentorsScheduledCallResponse';
import { AllMentorsScheduledCallRequest } from '../../models/super-admin/allMentorsScheduledCallResquest';
import { ListMindlerTestRequest } from '../../models/super-admin/listMindlerTestRequest';
import { MindlerTestRequestResponse } from '../../models/psychometric-test/psychometric-test.model';
import { UpdateMindlerTestRequestStatusRequest } from '../../models/super-admin/updateMindlerTestRequestStatusRequest';
import { MindlerTestRequestResponseSuperAdmin } from '../../models/super-admin/mindlerTestRequestResponseSuperAdmin';
import { AllStudentMentorRequest } from '../../models/super-admin/allStudentMentorRequest';
import { AllStudentMentorResponse } from '../../models/super-admin/allStudentMentorResponse';
import { UpdateStudentMentorStatusRequest } from '../../models/super-admin/updateStudentMentorStatusRequest';
import { YoutubeIntegrationStatusResponse } from '../../models/youtube/youtubeIntegrationStatusResponse';
import { YoutubeIntegrationRequest } from '../../models/youtube/youtubeIntegrationRequest';
import { PaymentReportRequest, PaymentReportResponse } from '../../models/paymentreport.model';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminService {

  constructor(private genericService: GenericService) { }

  listAdmins(getAdminRequest: GetAdminRequest): Observable<apiResponse<AdminResponse[]>>
  {
    return this.genericService.post(`admin`, getAdminRequest);
  }
  addAdmin(registerAdminRequest: RegisterAdminRequest): Observable<AdminResponse>
  {
    const documentData = new FormData();
    documentData.append('firstName', registerAdminRequest.firstName ?? '');
    documentData.append('lastName', registerAdminRequest.lastName ?? '');
    documentData.append('gender',registerAdminRequest.gender.toString());
    documentData.append('email',registerAdminRequest.email);
    documentData.append('phoneNumber',registerAdminRequest.phoneNumber);
    documentData.append('organizationName',registerAdminRequest.organizationName);
    documentData.append('website',registerAdminRequest.website ?? '');
    documentData.append('state',registerAdminRequest.state.toString());
    if(registerAdminRequest.imageUrl){
      documentData.append('imageUrl', registerAdminRequest.imageUrl, registerAdminRequest.imageUrl.name);  // Add file with its original name
    }
    return this.genericService.post(`admin/register`, documentData);
  }
  editAdmin(updateAdminRequest: UpdateAdminRequest): Observable<AdminResponse>
  {
    return this.genericService.patch(`admin`, updateAdminRequest);
  }
  listStudents(studentListForSuperAdminRequest: StudentListForSuperAdminRequest):Observable<apiResponse<StudentListForSuperAdminResponse[]>>
  {
    return this.genericService.post(`superadmin/student`, studentListForSuperAdminRequest);
  }
  loginAsMentorFromSuperAdmin(mentorId: string):Observable<loginResponse>
  {
    return this.genericService.get(`superadmin/mentor/login/${mentorId}`)
  }
  listAllMentorsScheduledCalls(allMentorsScheduledCallRequest:AllMentorsScheduledCallRequest):Observable<apiResponse<AllMentorsScheduledCallResponse[]>>
  {
    return this.genericService.post(`scheduledCalls/mentor`, allMentorsScheduledCallRequest);
  }
  getAllMindlerTestRequest(req: ListMindlerTestRequest): Observable<apiResponse<MindlerTestRequestResponseSuperAdmin[]>>
  {
    return this.genericService.post(`mindler/test/request`, req);
  }
  updateMindlerTestRequestStatus(req: UpdateMindlerTestRequestStatusRequest) : Observable<MindlerTestRequestResponse>
  {
    return this.genericService.patch(`mindler/testrequest`, req);
  }
  getStudentMentorForSuperAdmin(req: AllStudentMentorRequest): Observable<apiResponse<AllStudentMentorResponse[]>>
  {
    return this.genericService.post(`superadmin/studentMentors`, req);
  }
  updateStudentMentorStatus(req: UpdateStudentMentorStatusRequest): Observable<AllStudentMentorResponse>
  {
    return this.genericService.patch(`studentMentor/status`,req);
  }

  downloadStudentMentorList(req: any): Observable<HttpResponse<ArrayBuffer>> {
    return this.genericService.getBinaryPost(`download/superadmin/studentMentors`, req);
  }

  downloadMindlerTestList(req: any): Observable<HttpResponse<ArrayBuffer>> {
    return this.genericService.getBinaryPost(`download/mindler/test/request`, req);
  }

  getYouTubeIntegrationStatus(): Observable<YoutubeIntegrationStatusResponse> {
    return this.genericService.get(`youtube/status`);
  }

  activateYouTubeIntegration(request: YoutubeIntegrationRequest): Observable<void> {
    return this.genericService.post(`youtube/activate`, request);
  }

  deactivateYouTubeIntegration() {
    return this.genericService.delete(`youtube/deactivate`);
  }

  getPaymentReports(request: PaymentReportRequest): Observable<apiResponse<PaymentReportResponse>> {
    return this.genericService.post(`superadmin/payment/reports`, request);
  }

  exportPaymentReports(request: PaymentReportRequest): Observable<HttpResponse<ArrayBuffer>> {
    return this.genericService.getBinaryPost(`superadmin/payment/reports/export`, request);
  }
}
